export const styleTags: HTMLLinkElement[] = [];
export default function (linkTag: any): void {
  styleTags.push(linkTag);
}
